import React from "react";
import Page from "components/Page";
import { Props } from "./CatalogueItemCustomFields";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const CatalogueItemCustomFields = lazyWithRetry(() =>
  import("./CatalogueItemCustomFields")
);

export default (props: Props) => (
  <Page>
    <CatalogueItemCustomFields {...props} />
  </Page>
);
